<template>
    <div>
        <div id="wrapper" v-if="auth.loggedIn">
            <div class="topbar">
                <div class="topbar-left">
                    <router-link tag="a" :to="{ name: Routes.dashboard }" class="logo">
                        <span>
                            <img alt="" height="35" src="/images/logo/foundri-logo.png">
                        </span>
                        <i>
                            <img alt="" height="50" src="/images/logo/svg 2.svg">
                        </i>
                    </router-link>
                </div>
                <nav class="navbar-custom">
                    <ul class="navbar-right d-flex list-inline float-right mb-0">
                        <li class="dropdown notification-list">
                            <a class="nav-link dropdown-toggle arrow-none waves-effect" href="#" role="button"
                               @click.prevent="toggleNotifDropdown()"
                               aria-haspopup="false" aria-expanded="false">
                                <i class="ti-bell noti-icon"/>
                                <span class="badge badge-pill badge-danger noti-icon-badge">
                                    {{ unread_messages.data.length }}
                                </span>
                            </a>
                            <div
                                class="dropdown-menu dropdown-menu-right dropdown-menu-lg unread-messages-dropdown"
                                :class="{ 'show': show_notif_dropdown }"
                            >
                                <h6 class="dropdown-item-text">
                                    Unread Messages ({{ unread_messages.data.length }})
                                </h6>
                                <div class="slimscroll notification-item-list">
                                    <a href="#"
                                       @click.prevent="openMessage(unread_message)"
                                       class="dropdown-item notify-item"
                                       v-for="unread_message in unread_messages.data"
                                    >
                                        <p class="notify-details ml-0">{{ unread_message.subject_text }}
                                            <span class="text-muted message-content">{{
                                                    unread_message.body.substring(0, 90)
                                                }}...</span>
                                        </p>
                                    </a>
                                </div>
                            </div>
                        </li>
                        <li class="dropdown notification-list">
                            <div class="dropdown notification-list nav-pro-img">
                                <a aria-expanded="false"
                                   aria-haspopup="false"
                                   class="dropdown-toggle nav-link arrow-none waves-effect nav-user"
                                   data-toggle="dropdown" href="#"
                                   role="button">
                                    <img :src="auth.user.avatar ? auth.user.avatar : '/images/user-4.jpg'" alt="user" class="rounded-circle avatar-image">
                                </a>
                                <div class="dropdown-menu dropdown-menu-right profile-dropdown ">
                                    <router-link :to="{ name: Routes.profile }"
                                                 class="dropdown-item" href="#">
                                        <i class="mdi mdi-account-circle m-r-5"/>
                                        Profile
                                    </router-link>
                                    <div class="dropdown-divider"></div>
                                    <a @click.prevent="logout" class="dropdown-item text-danger" href="#">
                                        <i class="mdi mdi-power text-danger"/>
                                        Logout
                                    </a>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <ul class="list-inline menu-left mb-0">
                        <li class="float-left">
                            <button class="button-menu-mobile open-left waves-effect">
                                <i class="mdi mdi-menu"/>
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
            <div class="left side-menu">
                <div class="slimscroll-menu" id="remove-scroll">
                    <div id="sidebar-menu">
                        <ul class="metismenu" id="side-menu">
                            <li class="menu-title">Main</li>
                            <li
                                v-for="menu in filtered_menu_list"
                                v-if="hasRole(menu.roles) || !menu.roles"
                                >
                                <a
                                    :class="getMenuClass(menu.route_name)"
                                    @click.prevent="clickMenuItem(menu.route_name)"
                                    class="waves-effect"
                                    >
                                    <i v-html="menu.icon"/>
                                    <span>{{ menu.title }}</span>
                                    <span
                                        v-if="menu.route_name === Routes.deal && unread_messages.data.length > 0"
                                        class="menu-badge badge badge-pill badge-danger"
                                        >
                                        {{ unread_messages.data.length }}
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="clearfix"></div>
                </div>
            </div>
            <div class="content-page">
                <div class="content">
                    <div class="p-2 p-sm-4">
                        <router-view/>
                    </div>
                </div>
                <footer class="footer">
                    © 2023 - {{ new Date().getFullYear() }} Foundri.
                </footer>
            </div>
        </div>
        <div v-else>
            <router-view/>
        </div>
    </div>
</template>

<script>
import Roles from "@/constants/roles";
import Routes from "@/constants/routes";
import Actions from "@/constants/store/actions";
import AuthUtil from "@/utils/auth";
import Route from "@/utils/route";
import Message from "@/models/message";
import { POLL_INTERVAL } from "@/constants/intervals";

const {
  config: { phase2_enabled },
} = window.App.state

export default {
    data() {
        return {
            phase2_enabled,
            Routes,
            Roles,
            menu_list: [
                {
                    title: 'Dashboard',
                    route_name: Routes.dashboard,
                    icon: `<i class="mdi mdi-view-dashboard"/>`
                },
                {
                    title: 'Vehicle Search',
                    route_name: Routes.vehicle,
                    icon: `<i class="mdi mdi-car"/>`,
                    roles: Route.getRoles(Routes.vehicle)
                },
                {
                    title: 'My Inventory',
                    route_name: Routes.inventory,
                    icon: `<i class="mdi mdi-format-list-text"/>`,
                    roles: Route.getRoles(Routes.inventory)
                },
                {
                    title: 'Companies',
                    route_name: Routes.company,
                    icon: `<i class="mdi mdi-home-modern"/>`,
                    roles: Route.getRoles(Routes.company)
                },
                {
                    title: 'New Listing',
                    route_name: Routes.create_vehicle,
                    icon: `<i class="mdi mdi-plus"/>`,
                    roles: Route.getRoles(Routes.create_vehicle)
                },
                {
                    title: 'Vehicle Shortlist',
                    route_name: Routes.vehicle_shortlist,
                    icon: `<i class="mdi mdi-star"/>`,
                    roles: Route.getRoles(Routes.vehicle_shortlist)
                },
                {
                    title: 'Customer Enquiries',
                    route_name: Routes.customer_enquiry,
                    icon: `<i class="mdi mdi-comment-processing-outline"/>`,
                    roles: Route.getRoles(Routes.customer_enquiry)
                },
                {
                    title: 'Dealer to Dealer',
                    route_name: Routes.deal,
                    icon: `<i class="mdi mdi-handshake"/>`,
                    roles: Route.getRoles(Routes.deal)
                },
                {
                    title: 'Users',
                    route_name: Routes.user,
                    icon: `<i class="mdi mdi-account-multiple"/>`,
                    roles: Route.getRoles(Routes.user)
                },
                {
                    title: 'Profile',
                    route_name: Routes.profile,
                    icon: `<i class="mdi mdi-account"/>`,
                    roles: Route.getRoles(Routes.profile)
                },
                {
                    title: 'Settings',
                    route_name: Routes.settings,
                    icon: `<i class="mdi mdi-settings"/>`,
                    roles: Route.getRoles(Routes.settings)
                }
            ],
            show_notif_dropdown: false,
            unread_messages: {
                data: [],
                meta: {
                    loading: false,
                    fetched: false
                }
            },
            pollInterval: null,
            notificationCount: 0,
        }
    },
    mounted() {
        if (AuthUtil.loggedIn()) {
            this.initTaxonomies();
        }

        if (!!this.auth.user?.companies?.length) {
            this.initUnReadMessages();

            window.Bus.$on('initUnreadMessages', () => {
                this.initUnReadMessages()
            });

            this.startPolling();
        }
    },
    beforeDestroy() {
        this.stopPolling();
    },
    computed: {
        filtered_menu_list() {
            return this.menu_list.filter(menu => {
                if (menu.route_name === Routes.customer_enquiry && !phase2_enabled) {
                    return false;
                }
                return true
            });
        },
    },
    methods: {
        logout() {
            axios.post('/logout', {
                _token: this.$store.state.csrf
            })
                .then(() => {
                    location.href = '/login';
                })
        },
        getMenuClass(route_name) {
            return {
                'active': this.$route.matched.length && this.$route.matched[0].name === route_name
            }
        },
        initTaxonomies() {
            this.$store.dispatch(Actions.fetch_taxonomies);
        },
        clickMenuItem(route_name) {
            if (window.innerWidth < 769) {
                $("body").toggleClass("enlarged");
            }
            this.$nextTick(() => {
                this.$router.push({
                    name: route_name
                })
            });
        },
        fetchUnreadMessages() {
            return Message
                .custom('/web-api/message/unread')
                .include('model.creator')
                .get()
        },
        initUnReadMessages() {
            this.unread_messages.meta.loading = true;
            this.notificationCount = this.unread_messages.data.length;
            this.fetchUnreadMessages()
                .then((response) => {
                    this.unread_messages.data = response.data;
                    this.unread_messages.meta.fetched = true;
                })
                .finally(() => {
                    this.unread_messages.meta.loading = false;
                })
        },
        toggleNotifDropdown() {
            this.show_notif_dropdown = !this.show_notif_dropdown;
        },
        openMessage(unread_message) {
            this.toggleNotifDropdown();
            this.$router.push({
                name: Routes.message,
                params: {
                    deal_id: unread_message.deal_id,
                    customer_id: unread_message.created_by
                }
            });

            history.replaceState(null, '', this.$router.resolve({
                name: Routes.deal,
            }).href);
        },
        startPolling() {
            this.pollInterval = setInterval(this.initUnReadMessages, POLL_INTERVAL);
        },
        stopPolling() {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
    }
}
</script>

<style lang="scss" scoped>
.unread-messages-dropdown {
    width: 400px !important;
    @media (max-width: 576px) {
        max-width: 300px;
    }
    @media (max-width: 375px) {
        max-width: 230px;
    }
}
.avatar-image {
  width: 45px;
  height: 45px;
  object-fit: cover;
}
.menu-badge {
    margin: 0 !important;
    position: absolute;
    bottom: 20px;
}
</style>
